import { isType } from 'ts-action'
import { Action } from 'redux'
import { IRegionsReducer as ILocationReducer } from 'models/Region'
import { GetLocations, GetLocationsErrors, LocationsFetching } from './actions'

const initialState: ILocationReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  initialFetch: false,
  data: [],
}

export const locationReducer = (
  state = initialState,
  action: Action,
): ILocationReducer => {
  if (isType(action, GetLocations)) {
    const { payload } = action
    return {
      ...state,
      initialFetch: true,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, GetLocationsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, LocationsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  return state
}
